








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import HomeSection from "@/components/HomeSection.vue";
import ProductsSection from "@/components/ProductsSection.vue";
import SupportSection from "@/components/SupportSection.vue";
import PricesSection from "@/components/PricesSection.vue";
import ContactsSection from "@/components/ContactsSection.vue";

@Component({
	components: {
		HomeSection,
		ProductsSection,
		SupportSection,
		PricesSection,
		ContactsSection,
	}
})
export default class Home extends Vue {

	private sections: NodeListOf<Element> = null;
	private m_isScrolling: boolean = false;

	public loadSections(): void {
		this.sections = this.$el.querySelectorAll(".section");
	}

	protected get routeHash(): string {
		return this.$route.hash;
	}

	@Watch("$route")
	public onRouteHash(): void {
		if (this.m_isScrolling) {
			return;
		}

		this.scrollToElement(`#${this.$route.name.toLowerCase()}`);
	}

	private scrollToElement(id: string) {
		const section: Element = this.$el.querySelector(id);
		section.scrollIntoView(true);
	}

	public mounted(): void {
		this.onRouteHash();
	}

	protected async onSectionEnter(e): Promise<void> {

		if (e.percentInView < 0.5)
			return;

		this.m_isScrolling = true;

		if (this.$route.name.toLowerCase() !== e.target.element.id.toLowerCase()) {
			await this.$router.push(`/${e.target.element.id}`);
		}

		this.m_isScrolling = false;
	}
}
